const ActionTypes = {
  // General
  SHOW_ALERT: "SHOW_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  SHOW_RINGING: "SHOW_RINGING",
  HIDE_RINGING: "HIDE_RINGING",
  DECLINE_RINGING: "DECLINE_RINGING",
  SHOW_LOADING: "SHOW_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  GENERAL_TYPES: "GENERAL_TYPES",
  UPDATE_TYPES: "UPDATE_TYPES",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  // User
  GET_USER: "GET_USER",
  IsLogin: "IsLogin",
  IsLogout: "IsLogout",
  EmailNotification: "EmailNotification",

  //Assets
  GET_SINGLE_ASSETS: "GET_SINGLE_ASSETS",
  RESET_SINGLE_ASSETS: "RESET_SINGLE_ASSETS",
  SET_ASSETS_STATUS: "SET_ASSETS_STATUS",
  GET_UNLINK_ASSETS : "GET_UNLINK_ASSETS",
  RESET_UNLINK_ASSETS : "RESET_UNLINK_ASSETS",

  //Modules
  RESET_MODULES: "RESET_MODULES",
  GET_MODULES: "GET_MODULES",
  DLT_MODULE_FROM_ASSET: "DLT_MODULE_FROM_ASSET",
  //Pages
  GET_PAGES: "GET_PAGES",

  //Schedule
  GET_SCHEDULE : "GET_SCHEDULE"
};

export default ActionTypes;
